<template>
  <div>
    <ul class="select-option" style="overflow: hidden">
      <li>
        <span class="select-title">案件流程：</span>
        <el-cascader
          ref="process"
          v-model="flowCodeArr"
          :show-all-levels="false"
          :options="processOptions"
          :props="optionProps"
          class="user-input"
          placeholder="一级菜单"
          clearable
          collapse-tags
          @change="processChange"
        />
      </li>
      <!-- <li>
        <span class="select-title">案件风险度：</span>
        <el-cascader
			v-model="riskCode"
			:options="riskOptions"
			:props="riskProps"
			class="user-input"
			@change="riskChange"
			clearable
        ></el-cascader>
      </li> -->
      <li>
        <span class="select-title">案件标签：</span>
        <el-cascader
          v-model="caseTag"
          :options="caseTagOptions"
          :props="caseTagProps"
          class="user-input"
          clearable
          @change="caseTagChange"
        />
      </li>
      <li>
        <span class="select-title">事件ID：</span>
        <el-input
          v-model="caseId"
          placeholder="请输入事件ID"
          class="select-input"
          @keyup.enter.native="search"
        />
      </li>
      <li>
        <span class="select-title">申请人姓名：</span>
        <el-input
          v-model="applicantName"
          placeholder="请输入申请人姓名"
          class="select-input"
          @keyup.enter.native="search"
        />
      </li>
      <li>
        <span class="select-title">受助人姓名：</span>
        <el-input
          v-model="recRealName"
          placeholder="请输入受助人姓名"
          class="select-input"
          @keyup.enter.native="search"
        />
      </li>
      <li>
        <span class="select-title">受助人身份证号：</span>
        <el-input
          v-model="recIdno"
          maxlength="18"
          placeholder="请输入受助人身份证号"
          class="select-input"
          @keyup.enter.native="search"
        />
      </li>

      <li>
        <span class="select-title">当前处理账号：</span>
        <el-input
          v-model="currentProcessAccount"
          placeholder="请输入当前处理账号"
          class="select-input"
          @keyup.enter.native="search"
        />
      </li>

      <li>
        <span class="select-title">待办日期：</span>
        <el-date-picker
          v-model="createTime"
          type="date"
          placeholder="选择日期"
          value-format="yyyy-MM-dd"
          :picker-options="pickerOptions"
        />
      </li>

      <li style="display: block; width: 100%">
        <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
        <el-button type="primary" icon="iconfont icon-chakanxiangqing" @click="seecase">
          查看详情
        </el-button>
        <el-button
          v-if="checkPermission('全部案件:导出标签', permList)"
          type="primary"
          icon="iconfont icon-daochu"
          @click="exportTag"
        >
          导出标签
        </el-button>
      </li>
    </ul>

    <!-- 业管数据看板-表格 -->
    <el-table
      v-if="checkPermission('数据看板:个人看板', permList)"
      ref="ygDataTable"
      class="container-ygTable"
      border
      tooltip-effect="dark"
      :data="ygDataChartList"
    >
      <el-table-column
        prop="storeHouseName"
        label="数据内容"
        align="center"
        show-overflow-tooltip
      />
      <el-table-column
        prop="userName"
        label="姓名"
        align="center"
        show-overflow-tooltip
      />
      <el-table-column
        prop="stockCountNewOld"
        :label="'库存件数\n（新件/补件）'"
        align="center"
        show-overflow-tooltip
      />
      <el-table-column
        prop="warnCountNewOld"
        :label="'预警件数\n（新件/补件）'"
        align="center"
        show-overflow-tooltip
      />
      <el-table-column
        prop="overtimeCountNewOld"
        :label="'超时件数\n（新件/补件）'"
        align="center"
        show-overflow-tooltip
      />
      <el-table-column
        prop="overtimeRate"
        label="超时率"
        align="center"
        show-overflow-tooltip
      />
      <el-table-column
        prop="last31FlowIn"
        label="近31天流进个人库案件数"
        align="center"
        show-overflow-tooltip
      />
      <el-table-column
        prop="last31Pass"
        label="近31天通过件数"
        align="center"
        show-overflow-tooltip
      />
      <el-table-column
        prop="last31Refuse"
        label="近31天拒付件数"
        align="center"
        show-overflow-tooltip
      />
      <el-table-column
        prop="last31RefuseRate"
        align="center"
        label="近31天拒付率"
        show-overflow-tooltip
      />
    </el-table>

    <el-table
      ref="multipleTable"
      :data="tableData.records"
      border
      tooltip-effect="dark"
      style="width: 100%; margin-top: 15px"
      :row-style="rowStyle"
      :row-class-name="rowClassName"
      :cell-class-name="cellClassName"
      @selection-change="selectionChange"
      @row-click="rowClick"
    >
      <el-table-column
        label="序号"
        type="index"
        :index="indexMethod"
        width="50"
        align="center"
      />

      <el-table-column type="selection" width="60" align="center" />
      <el-table-column align="center" label="事件id" prop="caseId" width="150">
        <template scope="scope">
          <p :style="scope.row.caseStatus > 0 ? 'color:#639ee8; font-weight:bold;' : ''">
            {{ scope.row.caseId }}
          </p>
        </template>
      </el-table-column>
      <el-table-column align="center" width="180" prop="createTime" label="报案日期" />
      <el-table-column align="center" prop="recRealName" label="受助人姓名" show-overflow-tooltip />
      <el-table-column align="center" prop="productName" label="所属计划" show-overflow-tooltip>
        <template scope="scope">
          <span v-if="scope.row.lowerDegreeCommunicateStatus == false">{{
            scope.row.productName
          }}</span>
          <span v-else style="color: #37b328">{{ scope.row.productName }}</span>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="caseParentFlowName"
        label="事件状态"
        show-overflow-tooltip
      />
      <el-table-column
        align="center"
        prop="caseFlowName"
        label="当前处理状态"
        show-overflow-tooltip
      />
      <el-table-column
        align="center"
        prop="currentOperatorName"
        label="当前处理账号"
        show-overflow-tooltip
      />
      <el-table-column
        align="center"
        prop="endOperatorName"
        label="最后处理账号"
        show-overflow-tooltip
      />
      <el-table-column
        align="center"
        prop="adjustingUploadResultStatus"
        label="是否已完成公估回访"
        show-overflow-tooltip
        width="100"
      />
      <el-table-column
        align="center"
        prop="customerComplaint"
        label="是否已完成客诉子任务"
        show-overflow-tooltip
        width="100"
      />
      <el-table-column
        align="center"
        prop="feeCheckStatus"
        label="是否已完成去调查子任务"
        show-overflow-tooltip
        width="110"
      />
      <el-table-column
        align="center"
        prop="companyAdjustingStatus"
        label="是否已完成公估子任务"
        show-overflow-tooltip
        width="100"
      />
    </el-table>
    <div style="text-align: center; margin-top: 25px">
      <el-pagination
        :page-size="tableData.size"
        :current-page="pageIndex"
        background
        layout="total,prev, pager, next, jumper"
        :total="tableData.total"
        @current-change="pageChange"
      />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {

  data() {
    return {
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now()
        },
        shortcuts: [
          {
            text: '今天',
            onClick(picker) {
              picker.$emit('pick', new Date())
            }
          },
          {
            text: '昨天',
            onClick(picker) {
              const date = new Date()
              date.setTime(date.getTime() - 3600 * 1000 * 24)
              picker.$emit('pick', date)
            }
          },
          {
            text: '一周前',
            onClick(picker) {
              const date = new Date()
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', date)
            }
          }
        ]
      },
      loading: true,
      accessRole: 'ACCESS_MINE',
      limit: 10,
      pageIndex: 1,
      flowCode: '',
      flowCodeArr: [],
      riskCode: '',
      createTime: '',
      operatorTime: '',
      applicantName: '',
      recRealName: '',
      caseId: '',
      recIdno: '',
      accidentType: '',
      currentProcessAccount: '',
      caseTag: '',
      riskOptions: [
        {
          value: '4',
          label: '高风险',
          code: '4'
        },
        {
          value: '3',
          label: '较高风险',
          code: '3'
        },
        {
          value: '2',
          label: '低风险',
          code: '2'
        },
        {
          value: '1',
          label: '较低风险',
          code: '1'
        }
      ],

      riskProps: {
        expandTrigger: 'hover',
        emitPath: false,
        value: 'code',
        label: 'label',
        children: 'children'
      },

      caseTagOptions: [
        {
          value: '1',
          label: '特殊案件',
          code: '1'
        },
        {
          value: '2',
          label: '中转案件',
          code: '2'
        }
      ],

      caseTagProps: {
        expandTrigger: 'hover',
        emitPath: false,
        value: 'code',
        label: 'label',
        children: 'children'
      },

      processOptions: [],
      optionProps: {
        expandTrigger: 'hover',
        emitPath: false,
        multiple: true,
        value: 'flowCode',
        label: 'name',
        children: 'children'
      },
      tableData: {},
      selectRows: [],
      dialogData: [],
      dialogFormVisible: false,
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      currentCode: '',
      formLabelWidth: '120px',
      ygDataChartList: [] // 业管-个人数据看板表格数据
    }
  },

  computed: {
    ...mapState({
      permList: (state) => state.permission.permList
    }),

    selectRowsId() {
      const idArr = []
      if (this.selectRows.length > 0) {
        this.selectRows.filter((item) => {
          idArr.push(item.userId)
        })
      }
      return idArr
    }
  },

  created() {
    this.$emit('setCurrentMenu', '待办案件')
    this.getprocess()

    const jumpfrom = this.$route.query.from
    if (jumpfrom === 'casedetail') {
      const currentSearchData = JSON.parse(localStorage.getItem('currentSearchData'))
      this.accessRole = currentSearchData.accessRole
      this.limit = currentSearchData.limit
      this.pageIndex = currentSearchData.pageIndex
      this.flowCode = currentSearchData.flowCode
      this.flowCodeArr = currentSearchData.flowCode.split(',')
      this.createTime = currentSearchData.createTime
      this.operatorTime = currentSearchData.operatorTime
      this.applicantName = currentSearchData.applicantName
      this.recRealName = currentSearchData.recRealName
      this.recIdno = currentSearchData.recIdno
      this.caseId = currentSearchData.caseId
      this.caseTag = currentSearchData.caseTag
      this.accidentType = currentSearchData.accidentType
      this.currentProcessAccount = currentSearchData.currentProcessAccount
    }

    this.getallcase(
      this.accessRole,
      this.limit,
      this.pageIndex,
      this.flowCode,
      this.createTime,
      this.operatorTime,
      this.applicantName,
      this.recRealName,
      this.recIdno,
      this.caseId,
      this.caseTag,
      this.accidentType,
      this.currentProcessAccount
    )

    if (this.checkPermission('数据看板:个人看板', this.permList)) {
      this.fetchYGDataChart()
    }
  },

  methods: {
    getprocess() {
      const vm = this
      vm.axios
        .get(vm.homePath() + '/case/flow/select')
        .then((res) => {
          if (res.data.status === '000000') {
            const data = res.data.flowList
            vm.processOptions = vm.filterNull(
              vm.toTreeData(data, 'parentCode', 'flowCode')
            )
          } else {
            vm.$alert(res.data.message, '提示')
          }
        })
        .catch((error) => console.log(error))
    },

    filterNull(data) {
      const vm = this
      for (var i = 0; i < data.length; i++) {
        if (data[i].children.length < 1) {
          data[i].children = undefined
        } else {
          vm.filterNull(data[i].children)
        }
      }
      return data
    },

    indexMethod(index) {
      return (this.pageIndex - 1) * this.limit + index + 1
    },

    /**
     * 查找案件列表
     */
    getallcase(
      accessRole,
      limit,
      page,
      flowCode,
      createTime,
      operatorTime,
      applicantName,
      recRealName,
      recIdno,
      caseId,
      caseTag,
      accidentType,
      currentProcessAccount
    ) {
      const vm = this
      vm.axios
        .get(vm.homePath() + '/case/list', {
          params: {
            accessRole,
            limit,
            page,
            flowCode,
            createTime,
            operatorTime,
            applicantName,
            recRealName,
            recIdno,
            caseId,
            caseTag,
            accidentType,
            currentProcessAccount
          }
        })
        .then((response) => {
          const data = response.data
          if (data.status === '000000') {
            vm.loading = false
            vm.tableData = data.page
          } else {
            vm.$alert(data.message || '服务器繁忙，请稍后重试', '提示')
          }
        })
        .catch((error) => console.log(error))
    },

    search() {
      this.pageIndex = 1
      this.getallcase(
        this.accessRole,
        this.limit,
        this.pageIndex,
        this.flowCode,
        this.createTime,
        this.operatorTime,
        this.applicantName,
        this.recRealName,
        this.recIdno,
        this.caseId,
        this.caseTag,
        this.accidentType,
        this.currentProcessAccount
      )
    },

    rowClick(row, column, event) {
      const refsElTable = this.$refs.multipleTable
      const findRow = this.selectRows.find((c) => Number(c.rowIndex) === Number(row.rowIndex))
      if (findRow) {
        refsElTable.toggleRowSelection(row, false)
        return
      }
      refsElTable.clearSelection()
      refsElTable.toggleRowSelection(row)
    },

    rowStyle({ row, rowIndex }) {
      Object.defineProperty(row, 'rowIndex', {
        value: rowIndex,
        writable: true,
        enumerable: false
      })
    },

    rowClassName({ row, rowIndex }) {
      let rowName = ''
      const findRow = this.selectRows.find((c) => c.rowIndex === row.rowIndex)
      if (findRow) {
        rowName = 'current-row '
      }
      return rowName
    },

    cellClassName({ row, column, rowIndex, columnIndex }) {
      let cellName = ''
      if (this.tableData.records[rowIndex].overTime) {
        if (Number(columnIndex) === 2) {
          cellName = 'red'
        }
      }
      return cellName
    },

    selectionChange(rows) {
      this.selectRows = rows
    },

    changeOperator(val) {
      this.currentCode = val.code
    },

    seecase() {
      const vm = this
      if (vm.selectRows.length < 1) {
        vm.$alert('请选择一条记录', '提示', {
          confirmButtonText: '确定',
          type: 'warning'
        })
        return
      }

      if (vm.selectRows.length > 1) {
        vm.$alert('只能选择一条记录', '提示', {
          confirmButtonText: '确定',
          type: 'warning'
        })
        return
      }

      const currentSearchData = {
        accessRole: vm.accessRole,
        limit: vm.limit,
        pageIndex: vm.pageIndex,
        flowCode: vm.flowCode,
        createTime: vm.createTime,
        operatorTime: vm.operatorTime,
        applicantName: vm.applicantName,
        recRealName: vm.recRealName,
        recIdno: vm.recIdno,
        caseId: vm.caseId,
        caseTag: vm.caseTag,
        accidentType: vm.accidentType,
        currentProcessAccount: vm.currentProcessAccount
      }

      localStorage.setItem('currentSearchData', JSON.stringify(currentSearchData))
      this.$router.push({
        path: '/index/caseDetailV2/' + vm.selectRows[0].caseCode,
        query: {
          from: 'todo'
        }
      })
    },

    processChange(val) {
      this.flowCode = val.join(',')
    },

    riskChange(val) {
      this.riskCode = val
    },

    caseTagChange(val) {
      this.caseTag = val
    },

    handleChange(value) {
      this.selectRows = value
    },

    pageChange(val) {
      this.pageIndex = val
      this.getallcase(
        this.accessRole,
        this.limit,
        this.pageIndex,
        this.flowCode,
        this.createTime,
        this.operatorTime,
        this.applicantName,
        this.recRealName,
        this.recIdno,
        this.caseId,
        this.caseTag,
        this.accidentType,
        this.currentProcessAccount
      )
    },

    /**
     * 获取业管数据看板-个人
     */
    fetchYGDataChart() {
      const _this = this
      const date = new Date()
      date.setTime(date.getTime() - 24 * 60 * 60 * 1000)
      const yesterday =
        date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate() // 昨天的日期

      _this.axios
        .get(_this.homePath() + `/data-chart/query/user/${yesterday}`)
        .then((res) => {
          if (res.data.status === '000000') {
            const result = res && res.data && res.data.data
            const ygDataChartList = []

            result &&
              result.excel &&
              result.excel.forEach((item) => {
                item.detail &&
                  item.detail.forEach((zItem) => {
                    ygDataChartList.push({
                      storeHouseName: item.storeHouseName, // 数据内容
                      userName: zItem.userName, // 姓名
                      stockCountNewOld: zItem.stockCountNewOld || '0/0', // 库存件数（新件/补件）
                      warnCountNewOld: zItem.warnCountNewOld || '0/0', // 预警件数（新件/补件）
                      overtimeCountNewOld: zItem.overtimeCountNewOld || '0/0', // 超时件数（新件/补件）
                      overtimeRate: zItem.overtimeRate || '-', // 超时率
                      last31FlowIn: zItem.last31FlowIn || '0', // 近31天流进个人库案件数
                      last31Pass: zItem.last31Pass || '0', // 近31天通过件数
                      last31Refuse: zItem.last31Refuse || '0', // 近31天拒付件数
                      last31RefuseRate: zItem.last31RefuseRate || '-' // 近31天拒付率
                    })
                  })
              })
            _this.ygDataChartList = ygDataChartList
          } else {
            _this.$alert(res.data.message, '提示')
          }
        })
    },

    /**
     * 导出标签
     */
    exportTag() {
      const {
        accessRole,
        flowCode,
        createTime,
        operatorTime,
        applicantName,
        recRealName,
        recIdno,
        caseId,
        caseTag,
        accidentType,
        currentProcessAccount
      } = this

      window.location.href = this.homePath() + '/case/exportTag?accessRole=' + accessRole + '&recRealName=' + recRealName +
      '&recIdno=' + recIdno + '&flowCode=' + flowCode + '&createTime=' + createTime + '&operatorTime=' + operatorTime +
      '&applicantName=' + applicantName + '&caseId=' + caseId + '&caseTag=' + caseTag + '&accidentType=' + accidentType +
      '&currentProcessAccount=' + currentProcessAccount
    }
  }
}
</script>

<style>
.select-title {
  font-size: 14px;
  font-weight: 700;
}

.select-option li {
  float: left;
  margin: 10px;
}

.select-input {
  width: auto;
}

.el-table td,
.el-table th {
  padding: 6px 0px;
}

.el-table th {
  color: #333;
  font-weight: bold;
  text-align: center;
}

.container-ygTable {
  width: 100%;
  margin-top: 15px;
  margin-bottom: 45px;
}

.el-table .cell {
  white-space: pre-line;
}
</style>
